import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { useRef, useState } from "react";

export function useAutocompleteSuggestions(
    requestOptions
  ){
    const placesLib = useMapsLibrary("places");

    const placesLibRef = useRef(null);
    placesLibRef.current = placesLib;
  
    const sessionTokenRef =
      useRef(null);
  
    const [suggestions, setSuggestions] = useState([]);
  
    const fetchSuggestions = async (input) => {
      if (!placesLibRef.current ) {
        console.log('no google lib found', placesLibRef.current )
        return [];
      }
  
      const { AutocompleteSessionToken, AutocompleteSuggestion } = placesLibRef.current;
  
      if (!sessionTokenRef.current) {
        sessionTokenRef.current = new AutocompleteSessionToken();
      }
  
      const request = {
        ...requestOptions,
        input,
        sessionToken: sessionTokenRef.current
      };
      
      const res = await AutocompleteSuggestion.fetchAutocompleteSuggestions(
        request
      );
      return res?.suggestions ?? [];
    };
  
    return {
      fetchSuggestions,
      resetSession: () => {
        sessionTokenRef.current = null;
        setSuggestions([]);
      },
      isGoogleLibLoaded: !!placesLib
    };
  }